import { Pagination, Group, Button, createStyles } from "@mantine/core";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import React from "react";

const useStyles = createStyles((theme) => ({
  paginationContainer: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paginationItem: {
    "&[data-active]": {
      backgroundColor: theme.colors.gray[2],
      borderRadius: theme.radius.sm,
    },
  },
  navButton: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    color: theme.colors.gray[7],
    backgroundColor: "transparent",
    border: "none",
    fontWeight: 500,
    cursor: "pointer",
    padding: "5px 10px",
    "&:disabled": {
      color: theme.colors.gray[5],
      cursor: "not-allowed",
    },
  },
}));

const CustomBillingPagination = ({ data, itemsPerPage, currentPage, handlePageChange }) => {
  const { classes } = useStyles();
  const totalPages = Math.ceil(data / itemsPerPage);

  return (
    <div className={classes.paginationContainer}>
      <Group spacing="xs">
        {/* Previous Button */}
        <button
          className={classes.navButton}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <IconChevronLeft size={16} />
          Previous
        </button>

        {/* Pagination Numbers */}
        <Pagination
          total={totalPages}
          value={currentPage}
          onChange={handlePageChange}
          radius="md"
          classNames={{ item: classes.paginationItem }}
          color="dark"
        />

        {/* Next Button */}
        <button
          className={classes.navButton}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
          <IconChevronRight size={16} />
        </button>
      </Group>
    </div>
  );
};

export default CustomBillingPagination;
